/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global document, Office, Word */

import { VERSION } from "../../constants/environment";

import { getBaseRequestData, getAPIUrl, getRecordNumber } from "../../utils/requests";

Office.onReady((info) => {
  if (info.host === Office.HostType.Word) {
    $('#version').html(VERSION);

    updateValues();
  }
});

export async function updateValues() {
  return Word.run(async (context) => {
    let apiUrl = await getAPIUrl();
    $('#apiUrl').html(apiUrl);

    let recordNumber = await getRecordNumber();
    if(recordNumber !== null){
      $('#recordNumber').html(recordNumber);
    }
  });
}
